import { jsx } from 'react/jsx-runtime';
import 'luxon';
import 'react';
import styled from 'styled-components';
import '../../../../theme/GlobalStyle.js';
import 'react-helmet-async';
import 'lodash';
import ThemedComponentWrapper from '../../../../theme/ThemedComponentWrapper.js';
import 'ethereum-blockies-base64';
import '../../../icons/ActivityIcon.js';
import '../../../icons/ArrowDownIcon.js';
import '../../../icons/ArrowDownRightCircleIcon.js';
import '../../../icons/ArrowLeftAlignIcon.js';
import '../../../icons/ArrowLeftIcon.js';
import '../../../icons/ArrowRightAlignIcon.js';
import '../../../icons/ArrowRightIcon.js';
import '../../../icons/ArrowSwitchIcon.js';
import '../../../icons/ArrowUpIcon.js';
import '../../../icons/ArrowUpRightCircleIcon.js';
import '../../../icons/ArrowsAngleExpandIcon.js';
import '../../../icons/BankIcon.js';
import '../../../icons/CheckIcon.js';
import '../../../icons/ChevronDownIcon.js';
import '../../../icons/ChevronRightIcon.js';
import '../../../icons/ChevronUpIcon.js';
import '../../../icons/CopyIcon.js';
import '../../../icons/CrossIcon.js';
import '../../../icons/DaiIcon.js';
import '../../../icons/DangerIcon.js';
import '../../../icons/DownSortIcon.js';
import '../../../icons/ExclamationTriangleIcon.js';
import '../../../icons/ExpandKpiIcon.js';
import '../../../icons/EyeIcon.js';
import '../../../icons/EyeSlashIcon.js';
import '../../../icons/Grid1x2Icon.js';
import '../../../icons/InfoCircleIcon.js';
import '../../../icons/ListIcon.js';
import '../../../icons/LockIcon.js';
import '../../../icons/MediumIcon.js';
import '../../../icons/MoonIcon.js';
import '../../../icons/PiggyBankIcon.js';
import '../../../icons/QuestionMarkCircleIcon.js';
import '../../../icons/ShieldIcon.js';
import '../../../icons/SunIcon.js';
import '../../../icons/UpSortIcon.js';
import '../../../icons/XIcon.js';
import '../../../icons/InfinityIcon.js';
import '../../../icons/ArrowUpRightBoxIcon.js';
import '../../../atoms/layout/Stack/Stack.js';
import '../../../atoms/Table/components/Pagination/Pagination.js';
import '../../../atoms/Table/Table.js';
import '../../../atoms/ToggleSwitch.js';
import '@floating-ui/react';
import '../../../atoms/Tooltip/components/TooltipContext.js';
import '../../../molecules/CurrencyValue/components/Value.js';
import '../../../molecules/KpiCard/KpiCard.js';
import '../../../molecules/PercentageValue.js';
import '../../../molecules/Tabs/Tabs.js';
import '../../../molecules/TrendValue.js';
import '../../../pictograms/EthPictogram.js';
import '../../../pictograms/EtherScanPictogram.js';
import '../../../pictograms/DebankPictogram.js';
import '../../../pictograms/ZapperPictogram.js';
import '../../../pictograms/DaiPictogram.js';
import '../../../molecules/Modal/Modal.js';
import '../../ChartKpis/ChartKpi.js';
import '../../ChartJS.js';
import '../Heatmap.js';
import 'randomcolor';
import 'd3';
import '../../../XRay.js';

const Value = styled.span `
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  word-wrap: normal;
  border: 0;
`;
function HeatmapCell({ ref, children, ...rest }) {
    return (jsx(ThemedComponentWrapper, { ...rest, name: "heatmapCell", ref: ref, cursor: rest.onClick !== undefined ? 'pointer' : undefined, children: jsx(Value, { children: children }) }));
}

export { HeatmapCell as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhdG1hcENlbGwuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2NoYXJ0cy9IZWF0bWFwL2NvbXBvbmVudHMvSGVhdG1hcENlbGwudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFRoZW1lZENvbXBvbmVudFdyYXBwZXIgfSBmcm9tICdAaW5kZXgnO1xuaW1wb3J0IHsgVGhlbWVkQ29tcG9uZW50V3JhcHBlclByb3BzIH0gZnJvbSAnLi4vLi4vLi4vLi4vdGhlbWUvVGhlbWVkQ29tcG9uZW50V3JhcHBlcic7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ3N0eWxlZC1jb21wb25lbnRzJztcblxuY29uc3QgVmFsdWUgPSBzdHlsZWQuc3BhbmBcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB3aWR0aDogMXB4O1xuICBoZWlnaHQ6IDFweDtcbiAgcGFkZGluZzogMDtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgY2xpcDogcmVjdCgwLCAwLCAwLCAwKTtcbiAgd29yZC13cmFwOiBub3JtYWw7XG4gIGJvcmRlcjogMDtcbmA7XG5cbmludGVyZmFjZSBIZWF0bWFwQ2VsbFByb3BzXG4gIGV4dGVuZHMgT21pdDxUaGVtZWRDb21wb25lbnRXcmFwcGVyUHJvcHM8J3RkJz4sICduYW1lJz4ge31cblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gSGVhdG1hcENlbGwoe1xuICByZWYsXG4gIGNoaWxkcmVuLFxuICAuLi5yZXN0XG59OiBIZWF0bWFwQ2VsbFByb3BzKSB7XG4gIHJldHVybiAoXG4gICAgPFRoZW1lZENvbXBvbmVudFdyYXBwZXJcbiAgICAgIHsuLi5yZXN0fVxuICAgICAgbmFtZT1cImhlYXRtYXBDZWxsXCJcbiAgICAgIHJlZj17cmVmfVxuICAgICAgY3Vyc29yPXtyZXN0Lm9uQ2xpY2sgIT09IHVuZGVmaW5lZCA/ICdwb2ludGVyJyA6IHVuZGVmaW5lZH0+XG4gICAgICA8VmFsdWU+e2NoaWxkcmVufTwvVmFsdWU+XG4gICAgPC9UaGVtZWRDb21wb25lbnRXcmFwcGVyPlxuICApO1xufVxuIl0sIm5hbWVzIjpbIl9qc3giXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUlBLE1BQU0sS0FBSyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUE7Ozs7Ozs7OztDQVN4QjtBQUt1QixTQUFBLFdBQVcsQ0FBQyxFQUNsQyxHQUFHLEVBQ0gsUUFBUSxFQUNSLEdBQUcsSUFBSSxFQUNVLEVBQUE7QUFDakIsSUFBQSxRQUNFQSxHQUFDLENBQUEsc0JBQXNCLEVBQ2pCLEVBQUEsR0FBQSxJQUFJLEVBQ1IsSUFBSSxFQUFDLGFBQWEsRUFDbEIsR0FBRyxFQUFFLEdBQUcsRUFDUixNQUFNLEVBQUUsSUFBSSxDQUFDLE9BQU8sS0FBSyxTQUFTLEdBQUcsU0FBUyxHQUFHLFNBQVMsRUFBQSxRQUFBLEVBQzFEQSxJQUFDLEtBQUssRUFBQSxFQUFBLFFBQUEsRUFBRSxRQUFRLEVBQVMsQ0FBQSxFQUFBLENBQ0Y7QUFFN0I7Ozs7In0=
